import { ApiCore } from '@/services/api/utils/core.js'

const url = 'logout'
const plural = 'logout'
const single = 'logout'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.massUpdate = () => {
	// Custom API Logic
}

export default api
